<template>
  <q-dialog v-model="show" persistent>
    <q-card class="padding-horizontal-medium">
      <q-toolbar>
        <q-toolbar-title>
            <span class="text-weight-bold" v-if="start">Démarrage</span> 
            <span class="text-weight-bold" v-else>Arrêt</span> 
        </q-toolbar-title>
        <q-btn flat round dense icon="close" @click="$emit('cancel')" />
      </q-toolbar>

      <q-card-section>
        <div class="text-h6" v-if="start">Voulez-vous vraiment lancer le krach ?</div>
        <div class="text-h6" v-else>Voulez-vous vraiment stopper le krach ?</div>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn label="Annuler" color="secondary" flat class="q-ml-sm" @click="$emit('cancel')"/>
        <q-btn label="Oui" color="blue" flat @click="$emit('start')" v-if="start"/>
        <q-btn label="Oui" color="red" flat @click="$emit('stop')" v-else/>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
<script>
export default {
  name: "StartKrachDialog",
  props: {
    show: Boolean,
    start: Boolean,
  },
}
</script>
